import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { FormlySelectModule } from "@ngx-formly/core/select";
import { Message } from "primeng/message";
import { NewUiWrapperReadonlyComponent } from "../../shared/form/wrapper-readonly/new-ui-wrapper-readonly.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { NewUiLabelPipe } from "../../shared/form/label/new-ui-label.pipe";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";
import { NewUiRadiobuttonComponent } from "../../shared/form/radiobutton/new-ui-radiobutton.component";

@Component({
  selector: "new-ui-formly-radio",
  templateUrl: "./new-ui-formly-radio.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    FormlyModule,
    FormlySelectModule,
    AsyncPipe,
    Message,
    NewUiWrapperReadonlyComponent,
    NewUiLabelPipe,
    NewUiRadiobuttonComponent,
  ],
})
export class NewUiFormlyRadioComponent extends FieldType {
  override defaultOptions = {
    props: {
      hideLabel: true,
      options: [],
    },
  };
}
